import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

const KIT_CELL_WIDTH = 26;
const CENTER_BLOCK_MIN_WIDTH = 80;

export const getScoreboardMatchRowStyles = (theme: Theme) =>
  StyleSheet.create({
    pressableOuter: {
      alignSelf: 'stretch',
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingTop: 16,
      paddingBottom: 10,
      paddingHorizontal: 14,
      borderBottomWidth: 1,
      borderBottomColor: theme.gray[100],
    },
    rowLast: {
      borderBottomWidth: 0,
    },
    rowPressed: {
      opacity: 0.88,
    },

    // ── Name columns ──────────────────────────────────────────────────────────
    nameColumnLeft: {
      flex: 1,
      minWidth: 0,
      justifyContent: 'center',
      alignItems: 'flex-end',
      paddingRight: 4,
    },
    nameColumnRight: {
      flex: 1,
      minWidth: 0,
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingLeft: 4,
    },
    teamName: {
      fontSize: 13,
      fontWeight: '600',
      color: theme.gray[800],
      flexShrink: 1,
      lineHeight: 17,
      maxHeight: 34,
      textAlign: 'left',
    },
    teamNameLeft: {
      textAlign: 'right',
    },
    /** Loser team name in completed matches. */
    teamNameDim: {
      color: theme.gray[400],
    },

    // ── Kit cell ──────────────────────────────────────────────────────────────
    kitCell: {
      width: KIT_CELL_WIDTH,
      alignItems: 'center',
      justifyContent: 'center',
    },

    // ── Center block ──────────────────────────────────────────────────────────
    centerBlock: {
      minWidth: CENTER_BLOCK_MIN_WIDTH,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 4,
    },
    /** Absolutely positioned above the score — excluded from layout so score stays kit-aligned. */
    statusLabel: {
      position: 'absolute',
      top: -16,
      left: 0,
      right: 0,
      alignItems: 'center',
    },

    // ── Scheduled state ───────────────────────────────────────────────────────
    centerTime: {
      fontSize: 18,
      fontWeight: '800',
      color: theme.gray[800],
      letterSpacing: -0.5,
    },

    // ── Live state — pill badge ───────────────────────────────────────────────
    liveLabel: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 3,
      backgroundColor: theme.error,
      paddingHorizontal: 5,
      paddingVertical: 1,
      borderRadius: 9999,
    },
    liveDot: {
      width: 4,
      height: 4,
      borderRadius: 2,
      backgroundColor: theme.white,
    },
    liveLabelText: {
      fontSize: 8,
      fontWeight: '800',
      color: theme.white,
      letterSpacing: 0.6,
    },

    // ── Completed state ───────────────────────────────────────────────────────
    finalLabel: {
      fontSize: 10,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.8,
      textTransform: 'uppercase',
    },

    // ── Score row (live + completed) ──────────────────────────────────────────
    scoreRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    scoreDigit: {
      fontSize: 18,
      fontWeight: '800',
      color: theme.gray[800],
      letterSpacing: -0.5,
    },
    /** Loser score digit in completed matches. */
    scoreDigitDim: {
      color: theme.gray[400],
    },
    scoreSeparator: {
      fontSize: 18,
      fontWeight: '500',
      color: theme.gray[300],
    },

    pressableHover: {
      opacity: 0.95,
    },
  });
